module.exports = __webpack_public_path__ + "img/8fa024d.jpg";